import { render, staticRenderFns } from "./DisableTariff.vue?vue&type=template&id=51d7cde6&"
import script from "./DisableTariff.vue?vue&type=script&lang=js&"
export * from "./DisableTariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports